import { render, staticRenderFns } from "./ExtraSlotsModal.vue?vue&type=template&id=0604e55b&scoped=true"
import script from "./ExtraSlotsModal.vue?vue&type=script&lang=js"
export * from "./ExtraSlotsModal.vue?vue&type=script&lang=js"
import style0 from "./ExtraSlotsModal.vue?vue&type=style&index=0&id=0604e55b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0604e55b",
  null
  
)

export default component.exports